import { request } from '@utils';

export const downloadFile = async (path: string) => {
  const response = await request(
    {
      path,
      method: 'GET',
      authenticate: true,
      fileDownload: true,
    },
    true,
  );

  const binaryData = [];
  binaryData.push(response.data);
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/pdf' }));

  const [, filename] = response.headers['content-disposition'].match(/attachment; filename="(.*)"/i);

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
